import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { Injectable, Output, EventEmitter } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ConsultaList } from 'src/app/shared/model/core/ConsultaList.model';
import { Constantes } from 'src/app/utilerias/constantes/constantes';
import { Area } from 'src/app/shared/model/tickets/area.model';
import { Proyectos } from '../model/incidencias/proyectos.model';
import { EvidenciaBean } from '../model/incidencias/evidenciaBean.model';
import { TareaDiaria } from '../model/tarea/tareaDiaria.model';
import { Empleado } from '../model/empleado/empleado.model';
import { Proyecto } from '../model/gestion-proyectos/proyecto';



const API_URL = environment.apiUrl;

@Injectable({ providedIn: 'root' })
export class GenericoService {

    

    constructor(private http: HttpClient) { }



    /*isOpen = false;
    @Output() change: EventEmitter<boolean> = new EventEmitter();
  
    toggle() {
        this.isOpen = !this.isOpen;
        this.change.emit(this.isOpen);
    }*/


    private estatus = new BehaviorSubject<boolean>(false);
    public isOpen = this.estatus.asObservable();
    public getEstatusPantalla(estatus: boolean): void {
      this.estatus.next(estatus);
    }





    /**
     * Método en cargado de crear la ruta completa para las peticiones
     * @param url // url del recurso al que se desea acceder
     */
    public obtenerRutaCompleta = function (url: string) {
        return API_URL + 'controller/' + url;
    };
    public obtenerRuta = function (url: string) {
        return API_URL +  url;
    };

    /**
     * Método que obtiene la colección sin filtros
     * @param url // Ruta del elemento
     */
    public obtenerColeccion(url: string) {
        return this.http.get<any[]>(this.obtenerRutaCompleta(url), {
            responseType: 'json'
        });
    }

    /**
   * Obtiene el elemento correspondiente al parametro indicado
   * @param url
   * @param elemento
   */
    public obtenerColeccionPorCampo2(url: string, elemento: any): Observable<any[]> {
        const httpParams = new HttpParams().set('elemento', elemento);
        return this.http.get<any[]>(this.obtenerRutaCompleta(url), {
            params: httpParams,
            responseType: 'json'
        });
    }

    /**
     * Realiza una petición GET enviando los parámetros de paginación y búsqueda
     * @param {string} url - Url del recurso
     * @return {T} Genérico
     */
    public obtenerCollecionPorPagina(url: string, page: number, size: number, sort: string, search: string): Observable<any> {
        const httpParams = new HttpParams()
            .set('page', String(page))
            .set('size', String(size))
            .set('sort', String(sort))
            .set('search', String(search));
        return this.http.get<any>(this.obtenerRutaCompleta(url), {
            params: httpParams,
            responseType: 'json'
        });
    }

    /**
     * Realiza una petición GET enviando los parámetros de paginación y búsqueda
     * @param {string} url - Url del recurso
     * @return {T} Genérico
     */
    public obtenerCollecionPorConsultaList(url: string, data: ConsultaList<any>) {
        const httpParams = new HttpParams()
            .set('page', String(data.regInicial))
            .set('size', String(data.regXPagina))
            .set('sort', String(data.sort))
            .set('search', String(data.param1));
        return this.http.get<any>(this.obtenerRutaCompleta(url), {
            params: httpParams,
            responseType: 'json'
        });
    }

    consultarXPaginacion(url: string, req: ConsultaList<any>) {
        return this.http.post<ConsultaList<any>>(this.obtenerRutaCompleta(url), req);
    }

    /**
     * Realiza una petición GET enviando los parámetros de paginación y búsqueda
     * @param {string} url - Url del recurso
     * @return {T} Genérico
     */
    public obtenerCollecionPorRangos(url: string, page: number, size: number, total: number, search: string): Observable<any> {
        const httpParams = new HttpParams()
            .set('page', String(page))
            .set('size', String(size))
            .set('total', String(total))
            .set('search', String(search));
        return this.http.get<any>(this.obtenerRutaCompleta(url), {
            params: httpParams,
            responseType: 'json'
        });
    }

    /**
     * Realiza una petición GET enviando los parámetros de paginación y búsqueda
     * @param {string} url - Url del recurso
     * @return {T} Genérico
     */
    public obtenerCollecionConPaginacion(url: string, inicio: number, size: number, total: number, sort: string, search: string): Observable<any> {
        const httpParams = new HttpParams()
            .set('inicio', String(inicio))
            .set('size', String(size))
            .set('total', String(total))
            .set('sort', String(sort))
            .set('search', String(search));
        return this.http.get<any>(this.obtenerRutaCompleta(url), {
            params: httpParams,
            responseType: 'json'
        });
    }

    /**
     * Realiza una petición GET enviando los parámetros de paginación y búsqueda con (N parametros)
     * @param '{string}' url - Url del recurso
     * @return '{T}' Genérico
     */
    public obtenerCollecionPorPaginaConListaFiltros(url: string, page: number, size: number, sort: string, params: string[]): Observable<any> {
        let parametros = '';
        for (const val of params) {
            parametros += val + Constantes.SEPARATOR;
        }
        const httpParams = new HttpParams()
            .set('page', String(page))
            .set('size', String(size))
            .set('sort', String(sort))
            .set('search', String(parametros));
        return this.http.get<any>(this.obtenerRutaCompleta(url), {
            params: httpParams,
            responseType: 'json'
        });
    }


    /**
    * Obtiene el elemento correspondiente al parametro indicado
    * @param url
    * @param elemento
    */
   public obtenerElementoPorCampos(url: string, elemento: any[]){       

    const httpParams = new HttpParams()
    .set('elemento1', String(elemento[0].value))
    .set('elemento2', String(elemento[1].value))
    .set('elemento3', String(elemento[2].value));
    
    return this.http.get<any>(this.obtenerRutaCompleta(url), {
        params: httpParams,
        responseType: 'json'
    });
   }

    /**
    * Obtiene el elemento correspondiente al parametro indicado
    * @param url
    * @param elemento
    */
   public obtenerElementoPor2Campos(url: string, elemento: any[]){       

    const httpParams = new HttpParams()
    .set('elemento1', String(elemento[0]))
    .set('elemento2', String(elemento[1]));
    
    return this.http.get<any>(this.obtenerRutaCompleta(url), {
        params: httpParams,
        responseType: 'json'
    });
   }


    /**
    * Obtiene el elemento correspondiente al parametro indicado
    * @param url
    * @param elemento
    */
    public obtenerElementoPorCampo(url: string, elemento: any): Observable<any> {
        const httpParams = new HttpParams().set('elemento', elemento);
        return this.http.get<any>(this.obtenerRutaCompleta(url), {
            params: httpParams,
            responseType: 'json'
        });
    }

    /**
    * Obtiene el elemento correspondiente al parametro indicado
    *  @param url
    *  @param elemento
    */
    public obtenerElementoPorCampo2(url: string, elemento): Observable<any> {
        const httpParams = new HttpParams().set(Constantes.ELEMENTO, elemento);
        return this.http.get<any>(this.obtenerRutaCompleta(url), {
            params: httpParams,
            responseType: 'json'
        });
    }

    /**
     * Obtiene el elemento correspondiente al parametro indicado
     *  @param url
     *  @param flujo
     *  @param factory
     */
    public obtenerElementoPorCampoFactory(url: string, flujo: string, factory: any): Observable<any[]> {
        const httpParams = new HttpParams().set(Constantes.FACTORY, factory).set(Constantes.FLUJO, flujo);
        return this.http.get<any>(this.obtenerRutaCompleta(url), {
            params: httpParams,
            responseType: 'json'
        });
    }

    /**
     * Obtiene los privilegios deacuerdo al flujo y la ruta de la vista
     *  @param url
     *  @param flujo - vista
     * @param factory - ruta de la vista
     */
    public obtenerPrivilegios(url: string, flujo: string, factory: any): Observable<any> {
        const httpParams = new HttpParams().set(Constantes.FLUJO, flujo).set(Constantes.FACTORY, factory);
        return this.http.get<any>(this.obtenerRutaCompleta(url), {
            params: httpParams,
            responseType: 'json'
        });
    }

    /**
     * Obtiene el elemento correspondiente al parametro indicado
     * @param url
     * @param elemento
    */
    public obtenerElementoPorCampoPost(url: string, elemento: any): Observable<any> {
        return this.http.post<any>(this.obtenerRutaCompleta(url), elemento, {
            responseType: 'json'
        });
    }

    /**
     * Obtiene el elemento correspondiente al parametro indicado
     * @param url
     * @param elemento
    */
    public obtenerColeccionPorCampoPost(url: string, elemento: any): Observable<any[]> {
        return this.http.post<any[]>(this.obtenerRutaCompleta(url), elemento, {
            responseType: 'json'
        });
    }

    /**
    * Obtiene el elemento correspondiente
    * @param url
    * @param elemento
    */
    public obtenerElemento(url: string): Observable<any> {
        return this.http.get<any>(this.obtenerRutaCompleta(url), {
            responseType: 'json'
        });
    }

    /**
      * Obtiene el elemento correspondiente
      * @param url
      * @param elemento
      */
    public obtenerElemento2(url: string): Observable<any> {
        return this.http.get<any>(this.obtenerRutaCompleta(url), {
            responseType: 'json'
        });
    }

    /**
    * Obtiene el elemento correspondiente al parametro indicado
    * @param url
    * @param elemento
    */
    public ejecutaServicioSinObtenerElemento(url: string, elemento: any){
        const httpParams = new HttpParams().set('elemento', elemento);
        return this.http.get(this.obtenerRutaCompleta(url), {
            params: httpParams,
            responseType: 'json'
        });
    }

    /**
    * Obtiene el elemento correspondiente al parametro indicado
    * @param url
    * @param elemento
    */
   public ejecutaServicioSinObtenerElemento2(url: string, elem1: any, elem2: any){
    const httpParams = new HttpParams()
    .set('elementoUNO', String(elem1))
    .set('elementoDOS', String(elem2));
    
    return this.http.get(this.obtenerRutaCompleta(url), {
        params: httpParams,
        responseType: 'json'
    });
}

    /**
     * Agrega un nuevo elemento a la dirección indicada
     * @param url
     * @param elemento
     */
    public agregarElemento(url: string, elemento: any): Observable<any> {
        return this.http.post<any>(this.obtenerRutaCompleta(url), elemento, {
            responseType: 'json'
        });
    }

    /**
     * Actualiza un nuevo elemento a la dirección indicada
     * @param url
     * @param elemento
     */
    public acualizarElemento(url: string, elemento: any): Observable<any> {
        return this.http.post<any>(this.obtenerRutaCompleta(url), elemento);
    }

    /** Agrega el archivo a la ruta */
    public addFile(url: string, elemento: File, idElement: any) {
        const param = new FormData();
        param.append('file', elemento, elemento.name);
        return this.http.post<any>(this.obtenerRutaCompleta(url), param, {
            params: { idElement: idElement }
        });
    }

    public validaFecha(url: string, fechas: any): Observable<any> {
        return this.http.post<any[]>(this.obtenerRutaCompleta(url), fechas, {
            responseType: 'json'
        });
    }

    descargarBitacora(url: string, id: string) {
        const httpParams = new HttpParams().append('1', id);
       // const headers = new HttpHeaders({
       /*      'Content-Type': 'application/json; charset=utf-8',
            'Authorization': btoa('WEB'),
            'X-Requested-With': 'XMLHttpRequest'
        });
        return this.http.get(this.obtenerRutaCompleta(url),
            { headers: headers, responseType: 'blob'}); */
        //return this.http.get(this.obtenerRutaCompleta(url));
        return this.http.get(this.obtenerRutaCompleta(url), 
        { params: httpParams, responseType: 'blob'}); 
      }

      descargaEmpleadoColabolador(url:string,usuario: number,fechaInicio: string, fechaFin: string, area: number ){
        const httpParams = new HttpParams().set('usuario',String(usuario))
                                           .set("fechaInicio",fechaInicio)
                                           .set('fechaFin', fechaFin)
                                           .set('area',String(area));
        return this.http.get(this.obtenerRutaCompleta(url), 
        { params: httpParams, responseType: 'blob'}); 
      }
      descargarReporteByProyecto(url:string, proyecto: string, usuario: number, fechaInicio: string, fechaFin: string ){
        const httpParams = new HttpParams().set('proyecto',String(proyecto)).set('usuario',String(usuario))
                                           .set('fechaInicio', fechaInicio).set('fechaFin', fechaFin);
        return this.http.get(this.obtenerRutaCompleta(url),{ params: httpParams, responseType:'blob' })
                                    
      }
      reporteEmpleadoColabolador(beanEmpleado: ConsultaList<Empleado>, url: string) {
        return this.http.post<ConsultaList<Empleado>>(this.obtenerRutaCompleta(url), beanEmpleado, {});
      }

      reporteEmpleadoProyecto(beanProyecto: ConsultaList<Proyecto>, url: string) {
        return this.http.post<any>(this.obtenerRutaCompleta(url), beanProyecto, {});
      }

      descargarBitacoras(url: string, proyecto:number, usuario:number, fechaInicio: string, fechaFin: string, area:number) {
        const httpParams = new HttpParams()
        .set('usuario',String(usuario))
        .set('proyecto', String(proyecto))
        .set("fechaInicio",fechaInicio)
        .set('fechaFin', fechaFin)
        .set('area', String(area));
      
        return this.http.get(this.obtenerRutaCompleta(url), 
        { params: httpParams, responseType: 'blob'}); 
      }
    

    /** Recupera reportes */
    public recuperaReporte(url: string, elemento: any): Observable<any> {
        const httpParams = new HttpParams().set('reporte', elemento);
        const headers = new HttpHeaders({
            'Content-Type': 'application/pdf',
            'Authorization': btoa('WEB'),
            'X-Requested-With': 'XMLHttpRequest'
        });
        return this.http.get(API_URL + url, {
            params: httpParams,
            headers: headers,
            responseType: 'arraybuffer'
        });

    }
    public recuperaReporteParam(url: string, elemento: any, param: any): Observable<any> {
        const httpParams = new HttpParams()
        .set('reporte', String(elemento))
        .set('param', String(param));

        const headers = new HttpHeaders({
            'Content-Type': 'application/pdf',
            'Authorization': btoa('WEB'),
            'X-Requested-With': 'XMLHttpRequest'
        });
        return this.http.get(API_URL + url, {
            params: httpParams,
            headers: headers,
            responseType: 'arraybuffer'
        });
    }

    consultarArea(url: string) {
        return this.http.post<ConsultaList<Area>>(url, {});
      }

      consultaproyectos(beanproyectos: Proyectos, url: string) {
        return this.http.post<ConsultaList<Proyectos>>(url,
          beanproyectos,
          {}
        ); // Consulta gestion de incidencias con paginacion
      }



      /**
    * Obtiene el elemento correspondiente al parametro indicado
    * @param url
    * @param elemento
    */
   public descargaEvidencia(url: string, elem0: any, elem1: any, elem2: any, elem3: any){
    const httpParams = new HttpParams()
    .set('tipo', String(elem0))
    .set('idProyecto', String(elem1))
    .set('id', String(elem2))
    .set('nombre', String(elem3));
    
    return this.http.get(this.obtenerRutaCompleta(url), {
        params: httpParams,
        responseType: 'blob'
    });}

    consultaVideoEvidencia(url: string, evidencia: EvidenciaBean) {
        return this.http.post(this.obtenerRutaCompleta(url), evidencia, {
          responseType: 'blob'
        }); 
      }
    
     
    
}
